import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { ParallaxProvider } from "react-scroll-parallax";
import './App.css';
import Navbar from './pages/Navbar';
import Footer from './pages/Footer';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import Services from './components/Services';
import ScrollToTop from './components/ScrollToTop';
import ScrollTopButton from './components/ScrollTopButton';
import WhatsAppButton from './components/WhatsAppButton';
// import CustomCursor from './components/Customcursor';
import Invoice from './components/Invoice';
import PrivacyPolicyTerms from './components/PrivacyPolicyTerms';

function App() {

  return (
    <div className="App">
      <ParallaxProvider>
        <BrowserRouter>
          {/* <CustomCursor /> */}
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services" element={<Services />} />
            <Route path="/customer-invoice-data" element={<Invoice />} />
            <Route path="/privacypolicyterms" element={<PrivacyPolicyTerms />} />
          </Routes>
          <Footer />
          <ScrollTopButton />
          <WhatsAppButton />
        </BrowserRouter>
      </ParallaxProvider>
    </div>
  );
}

export default App;